// extracted by mini-css-extract-plugin
module.exports = {"cards":"CardFan_cards__3fGEP","card":"CardFan_card__bt8Az"};